import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles';
import Skeleton from '../../../Common/Skeleton/Skeleton';
import s from './SubCategorySkeleton.css'

function SubCategorySkeleton() {

    return (
        <div className={s.subCategorySkeletonListContainer}>
            {[1, 2, 3].map(n =>
                <div key={n} className={s.subCategorySkeletonListItem}>
                    <Skeleton className={s.subCategorySkeletonListItemImg} />
                    <div className={s.subCategorySkeletonListItemInfoContainer}>
                        <Skeleton className={s.subCategorySkeletonTitle} />
                        <Skeleton className={s.subCategorySkeletonDesc} />
                        <Skeleton className={s.subCategorySkeletonLarge} />
                        <Skeleton className={s.subCategorySkeletonButton} />
                    </div>
                </div>)}
        </div>
    )
}

export default withStyles(s)(SubCategorySkeleton);
